<template>
    <div>
        <GmapMap
            :center="{lat:-2.548926, lng:118.0148634}"
            :zoom="5"
            map-type-id="terrain"
            style="width: 100%; min-height: 500px"
        >
            <GmapCluster>
                <gmap-marker v-for="(m, index) in markers"
                    :position="m.lat ? m: {lat: 0.00000 , lng: 0.0000}"
                    :clickable="true" :draggable="true"
                    :key="index"
                ></gmap-marker>
            </GmapCluster>
        </GmapMap>
    </div>
</template>

<script>
    import GmapCluster from 'vue2-google-maps/src/components/cluster' // replace src with dist if you have Babel issues

    export default {
        data () {
            return {
                markers : null,
            }
        },
        props : ['data'],
        components : {
            GmapCluster,
        },
        mounted () {
            // this.generateDummyData();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                this.markers = this.data && this.data.length > 0 ? this.data : [];
            },
            generateDummyData () {
                let markers = [];

                //Jakarta
                for (var i = 0; i < this.randomInt(100, 200); i++) {
                    markers.push({
                        lat : -6.241324 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001,
                        lng : 106.852188 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001
                    })
                }

                //Semarang
                for (var i = 0; i < this.randomInt(500, 800); i++) {
                    markers.push({
                        lat : -7.037214 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001,
                        lng : 110.430320 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001
                    })
                }

                //Jogja
                for (var i = 0; i < this.randomInt(70, 150); i++) {
                    markers.push({
                        lat : -7.794068 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001,
                        lng : 110.373629 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001
                    })
                }

                //Palembang
                for (var i = 0; i < this.randomInt(50, 200); i++) {
                    markers.push({
                        lat : -2.968338 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001,
                        lng : 104.777382 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001
                    })
                }

                //Pontianak
                for (var i = 0; i < this.randomInt(50, 200); i++) {
                    markers.push({
                        lat : -0.025610 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001,
                        lng : 109.342880 + (this.randomInt(0, 10)%2 ? 1 : -1) * this.randomInt(0, 100000) * 0.000001
                    })
                }
                this.markers = markers;
            },
        }
    }
</script>

<style scoped>

</style>